/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationInput } from './oralExamSubEvaluationInput';

export type TaskGradeInputSubEvaluations = OralExamSubEvaluationInput[] | null;
